
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/earnings",
      function () {
        return require("private-next-pages/embed/earnings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/earnings"])
      });
    }
  